import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import LoginPage from "./containers/login-page";
import EditorPage from "./containers/editor-page";

function NoMatch() {
  let location = useLocation();

  return (
    <div>
      <h3>
        No match for <code>{location.pathname}</code>
      </h3>
    </div>
  );
}

export default function RoutedApp() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <LoginPage />
        </Route>
        <Route path="/note/:id" children={<EditorPage />} />
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </Router>
  );
}
